import { evaluateUpdate } from './update.js';
import { describeShell } from './connectivity.js';
import { resolveInitialRoute } from './navigation.js';
export async function bootApp(deps) {
    const session = await deps.sessionStore.load();
    const update = evaluateUpdate({ current: deps.currentVersion, policy: deps.updatePolicy });
    const shell = describeShell(deps.network);
    const accountRoute = deps.accountRoute?.(session);
    const ctx = {
        session,
        update: update.decision,
        consent: deps.consent,
        network: deps.network,
        ...(accountRoute !== undefined ? { accountRoute } : {}),
    };
    const initial = resolveInitialRoute(deps.guards, deps.fallbackRoute, ctx);
    return {
        session,
        update,
        consent: deps.consent,
        shell,
        route: initial.route,
        ...(initial.forcedByGuard !== undefined ? { routeForcedByGuard: initial.forcedByGuard } : {}),
    };
}
//# sourceMappingURL=boot.js.map